import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import * as dayjs from 'dayjs';
import { Dayjs } from 'dayjs';
import 'dayjs/locale/uk';

// Імпорт плагіна
import * as localeData from 'dayjs/plugin/localeData';

// Активація плагіна
dayjs.extend(localeData);
dayjs.locale('uk');


@Injectable()
export class DayjsDateAdapter extends DateAdapter<Dayjs> {

  override getYear(date: Dayjs): number {
    return date.year();
  }

  override getMonth(date: Dayjs): number {
    return date.month();
  }

  override getDate(date: Dayjs): number {
    return date.date();
  }

  override getDayOfWeek(date: Dayjs): number {
    return date.day();
  }

  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    const locale = dayjs().localeData();
    if (style === 'short' || style === 'narrow') {
      return locale.monthsShort();
    }
    return locale.months();
  }

  override getDateNames(): string[] {
    return Array.from({ length: 31 }, (_, i) => String(i + 1));
  }

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    const locale = dayjs().localeData();
    if (style === 'short') {
      return locale.weekdaysShort();
    }
    if (style === 'narrow') {
      return locale.weekdaysMin();
    }
    return locale.weekdays();
  }

  override getYearName(date: Dayjs): string {
    return date.year().toString();
  }

  override getFirstDayOfWeek(): number {
    return 1;
  }

  override getNumDaysInMonth(date: Dayjs): number {
    return date.daysInMonth();
  }

  override clone(date: Dayjs): Dayjs {
    return date.clone();
  }

  override createDate(year: number, month: number, date: number): Dayjs {
    return dayjs(new Date(year, month, date));
  }

  override today(): Dayjs {
    return dayjs();
  }

  override parse(value: any): Dayjs | null {
    if (!value) return null;
    const parsed = dayjs(value, 'DD-MM-YYYY', true);
    return parsed.isValid() ? parsed : dayjs(value);
  }

  override format(date: Dayjs, displayFormat: any): string {
    return date.format(displayFormat || 'DD-MM-YYYY');
  }

  override addCalendarYears(date: Dayjs, years: number): Dayjs {
    return date.add(years, 'year');
  }

  override addCalendarMonths(date: Dayjs, months: number): Dayjs {
    return date.add(months, 'month');
  }

  override addCalendarDays(date: Dayjs, days: number): Dayjs {
    return date.add(days, 'day');
  }

  override toIso8601(date: Dayjs): string {
    return date.toISOString();
  }

  override isDateInstance(obj: any): boolean {
    return dayjs.isDayjs(obj);
  }

  override isValid(date: Dayjs): boolean {
    return date?.isValid?.() ?? false;
  }

  override invalid(): Dayjs {
    return dayjs('invalid');
  }

  override deserialize(value: any): Dayjs | null {
    if (!value) return null;
    return dayjs(value);
  }

  override compareDate(first: Dayjs, second: Dayjs): number {
    return first.startOf('day').diff(second.startOf('day'), 'day');
  }
}
